import React from 'react'

export default function Text ({ text }) {
  return (
    <div style={{ fontSize: '18px', padding: '0.5em 20px' }}>
      {text}
    </div>
  )
}
